import React  from 'react';

type BgisDetailProps = {
};

export const BgisDetailsSplitter: React.FC<BgisDetailProps> = ( ) => {
     return (
        <div className="bgis-details-splitter bgis-icon">
          <i className="bgis-icon bgis-icon-minus"></i>
        </div>
    );
};
